__turbopack_context__.v({
  "container": "error-module-scss-module__xFlJ4G__container",
  "description": "error-module-scss-module__xFlJ4G__description",
  "subtitle": "error-module-scss-module__xFlJ4G__subtitle",
  "title": "error-module-scss-module__xFlJ4G__title",
});
